export default "__VITE_ASSET__73000960__"